export default "__VITE_ASSET__DZxNyxe7__"